import React from 'react';
import PropTypes from 'prop-types';
import ComponentLoader from '../../global/ComponentLoader/ComponentLoader';

const multiRequestImportFunc = () => {
    return import(/* webpackChunkName: "MultiRequestModal" */
    './SharedMultiRequestModalWrapper').then(mod => mod.default);
};

export default function MultiRequestModalLoader(props) {
    return <ComponentLoader {...props} load={props.load} importFunc={multiRequestImportFunc} />;
}

MultiRequestModalLoader.propTypes = {
    load: PropTypes.bool.isRequired,
};
